<template>
  <Dropdown placement="top-left">
    <template #trigger>
      <div class="tweaks__item">
        <i class="bi bi-globe-americas"></i>
        <span>{{ $t('app.sidebar.language.title') }}</span>
      </div>
    </template>
    <template #menu="{ close }">
      <div class="dropdown__menu">
        <div class="dropdown__item" @click="setLocale('fr'); close()">
          <span class="fi fi-fr"></span>
          <span>{{ $t(`other.languages.fr`) }}</span>
        </div>
        <div class="dropdown__item" @click="setLocale('en'); close()">
          <span class="fi fi-gb"></span>
          <span>{{ $t(`other.languages.en`) }}</span>
        </div>
      </div>
    </template>
  </Dropdown>
</template>

<script lang="ts" setup>
import Dropdown from '@/components/global/Dropdown.vue';
import { setLocale } from '@/i18n';

const appStore = useAppStore();
</script>